import { Box, Typography } from '@mui/material';
import { FC } from 'react';

interface Props {
  title: string;
}

const RecommendationResultsSection: FC<Props> = ({
  title,
  children,
  ...rest
}) => (
  <Box marginTop={9} {...rest}>
    <Typography
      fontWeight={500}
      fontSize={12}
      lineHeight="20px"
      letterSpacing={1}
      marginBottom={2}
    >
      {title}
    </Typography>
    {children}
  </Box>
);

export default RecommendationResultsSection;
